import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { SearchContext } from "./utils/types";
import SearchPageContent from "./SearchPageContent";

export default function SearchPage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<SearchContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (context && !context.payload) {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {(context: SearchContext) => {
        const { kind, data } = context;

        // Load article page content.
        if (kind === "static") {
          return <SearchPageContent data={data} />;
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
